import { CardActions, CircularProgress, colors, Grid, ImageList, ImageListItem, ImageListItemBar } from "@material-ui/core";
import MaterialTable from "material-table";
import React from "react";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { CardActionArea, Button } from '@material-ui/core';
import theminable from '../../../../assets/img/thimanabl.png';
import oil91 from '../../../../assets/img/oil91.jpg';
import oil95 from '../../../../assets/img/oil95.jpg';
import dezal from '../../../../assets/img/dezal.jpg';



function ItemsCard(props) {
    const { item, isPurches, isStock, onClick ,AutoOptions} = props;
    return (
        <Card
             sx={{ maxWidth: 500,  }} 
            color="primary" style={{
                padding: '1px',
                backgroundColor:AutoOptions?.permType?.id === 4? item.symbol.includes("91") ?
                    colors.green[500] : item.symbol.includes("95") ? colors.red[500] :
                        item.symbol.includes("dezal")? "#a8a232": 
                        item?.symbol.includes("ديزل") ? "#a8a232" :
                         colors.green[500]:colors.green[500],
                color: '#fff',
                direction: 'rtl',
                minWidth:120              
            }}
            onClick={() => onClick(item.id, item.units)}>
            <CardActionArea>
                {
                    item.symbol.includes("91") && AutoOptions?.permType?.id === 4 ?
                        <CardMedia
                            component="img"
                            height="100"
                            image={oil91}
                            alt="green iguana"
                        /> : item.symbol.includes("95")  && AutoOptions?.permType?.id === 4  ?
                            <CardMedia
                                component="img"
                                height="100"
                                image={oil95}
                                alt="red iguana"
                            /> : (item.symbol.includes("dezal") ||item?.symbol.includes("ديزل"))
                             && AutoOptions?.permType?.id === 4   ?
                                <CardMedia
                                    component="img"
                                    height="100"
                                    image={dezal}
                                    alt="green iguana"
                                /> :
                                <CardMedia
                                    component="img"
                                    height="100"
                                    image={theminable}
                                    alt="green iguana"
                                />
                }

                <CardContent style={{
                    paddingTop: '2px',
                    minHeight: 55,
                    // minWidth:"%100"
                }}>
                    <Typography variant="subtitle2" component="div">
                        {item.symbol}
                    </Typography>
                    <Typography style={{ color: 'black' }} variant="subtitle2" component="div">
                        {item.nameEN}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
const OilItemsList = (props) => {

    const {
        loading,
        cuRows,
        AutoOptions,
        onRowClicks,
        isPurches,
        isStock,
    } = props;
    // var newItems = cuRows.filter((obj) => obj.id == pump.item  );

    return (
        <div style={{ padding: '8px' }}>
            <Grid container  spacing={1} >
                {

                    cuRows.map((item, i) => (
                        <Grid item lg={2} md={2} sm={3} xs={6}>
                            <ItemsCard
                                item={item}
                                isPurches={isPurches}
                                isStock={isStock}
                                onClick={() => onRowClicks(item)}
                                AutoOptions={AutoOptions}
                            />
                        </Grid>


                    ))
                }
            </Grid>
        </div>
    )
}

export default OilItemsList;